<div class="page-title-area">
    <img src="assets/images/jain.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2> University </h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Case Studies Details</li>
            </ul> -->
        </div>
    </div>

  <!--   <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <div class="services-img mb">
                    <img src="assets/images/case-details/1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-12">
                <div class="services-details-text">
                    <h2>Joe’s Company Software Development Case</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum  not only five centuries, but also the leap into.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a dictionary of over 200 Latin words, combined with a</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc generators on the Internet tend to repeat predefined chunks as necessary, making this the first generator dictionary of over 200 Latin words, combined with a.</p>
                </div>
            </div>
        </div> -->
       <!--  <div class="section-title">
            <div style="display: flex; flex-direction: row; text-align: center; justify-content: center;">
            <div><a href="https://www.jainuniversity.ac.in/" target="_blank"><h2> University  &nbsp;</h2></a></div>
            <div style="margin-top: 4px;">
                <a href="https://www.jainuniversity.ac.in/" target="_blank"><span class="material-symbols-outlined" style="font-size: 35px; font-weight: 600;">
                    arrow_outward
                    </span></a>
            </div>
            </div>
        </div> -->

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                           <!--  <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/29.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>About customer</h3>
                    <p>This Deemed-to-be University is a prestigious institution in
                        Bangalore, committed to providing top-notch education in various fields, including
                        app development and content creation.</p>
                    <h3>Business Challenge</h3>
                    <p>The primary challenge was to efficiently install and configure
                        over 50 iMacs in the University's Apple Lab. The goal was to ensure seamless
                        operation and accessibility for students focusing on app development and
                        content creation, thereby enhancing their practical learning experience.</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h3>Approach</h3>
                    <p>A dedicated team of IT professionals was assembled to manage the
                        procurement, installation, and configuration of the iMacs, ensuring they were
                        loaded with the necessary software and resources.</p>
                    <h3>Usage</h3>
                    <p>Over 50 iMacs were installed and configured in the Apple Lab. These
                        iMacs are used by students for app development and content creation, providing
                        them with access to cutting-edge technology for hands-on learning.</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                         <!--    <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/50.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                           <!--  <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/37.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Outcomes</h3>
                    <p>The installation was completed within the scheduled timeframe, with
                        all iMacs fully operational. Students now have access to advanced technology,
                        significantly enhancing the learning environment and enabling them to engage in
                        practical learning experiences.</p>
                        <h3>Apple and Partner solutions demonstrated</h3>
                        <p>Superior Digital provided 30 iMacs to this university for a versatile student lab focused on Content Creation and App
                            Development across various disciplines. We also conducted a comprehensive Train-the-Trainer program, empowering
                            faculty to confidently guide students in leveraging Macs for diverse academic and creative projects.</p>
                </div>
            </div>
        </div>
        
        <!-- <div class="scrives-item-3 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <h3>Conclusion</h3>
                    <p>Essilor’s adoption of iPads highlights the importance of digital tools in modernising sales operations, ultimately enhancing customer engagement and business outcomes.</p>   
                </div>
            </div>
        </div> -->
        <br>
        <br>
        <span style="font-size: 14px; color: #f10909; text-align: center;">Disclaimer: Company names have been withheld
            due to copyright and legal approvals, but full details can be shared upon request.</span>
    </div>
</section>